'use strict';

var last = require('./last');
var truncate = require('./truncate');

module.exports = function (item) {
  return [truncate(item), last(item)];
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/truncateLast.js
// module id = 559
// module chunks = 37